<template>
    <b-overlay :show="loading" opacity="0.2">
        <div class="container">
            <div class="col-md-12 mt-2">
                <div class="logo-wrapper bg-white">
                    <img class="logo p-2" :src="require('@/assets/images/logo/vuexy-logo.png')" />
                </div>
            </div>
            <div class="col-md-12">
                <div class="invoice">
                    <div class="font-weight-bolder d-flex align-items-center justify-content-between">
                        <h1 class="mb-0">Dekont Bilgisi: <h3>{{$safe(receipt,'SystemReceiptCode')}}</h3></h1>
                        <span class="d-print-none">
                            <button class="btn btn-sm btn-white" v-on:click="print">
                                <feather-icon icon="PrinterIcon" class="mr-50"></feather-icon>
                                Yazdır
                            </button>
                        </span>
                    </div>
                    <div class="invoice-header">
                        <div class="invoice-from">
                            <h4>Müşteri Bilgileri</h4>
                            <address class="mt-2 mb-2">
                                <strong>Müşteri: {{$safe(receipt,'CariName') || '-'}}</strong><br>
                                <!-- <strong>Ödeme Yapılan Banka: {{$safe(receipt,'Bank') || '-'}}</strong><br>
                                <strong>Kart Üzerindeki İsim: {{$safe(receipt,'CardHolderName') || '-'}}</strong><br> -->
                            </address>
                        </div>
                        <div class="invoice-date">
                            <small>&nbsp;</small>
                            <div class="date text-inverse mt-2">İşlem Tarihi: {{$safe(receipt,'PaymentTime') || '-'}}</div>
                        </div>
                    </div>
                    <div class="invoice-content">
                        <h4>Ödeme Bilgileri</h4>
                        <div class="table-responsive">
                            <table class=" mt-2 table w-100 table-invoice table-bordered" v-if="($safe(receipt,'Details') || []).length">
                                <thead>
                                    <tr>
                                        <th class="w-25 text-nowrap">Ödeme Tarihi</th>
                                        <th class="w-25 text-nowrap">Banka</th>
                                        <th class="w-25 text-nowrap">Kart Üzerindeki İsim</th>
                                        <th class="w-25 text-nowrap">Kart Bilgisi</th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(detail,index) in receipt.Details.filter(d=> d.Status != 7 )" :key="index">
                                        <td>{{$safe(detail,'LastUpdateTime') || '-'}}</td>
                                        <td>{{$safe(receipt,'Bank') || '-'}}</td>
                                        <td>{{$safe(receipt,'CardHolderName') || '-'}}</td>
                                        <td>{{$safe(receipt,'CardInformation') || '-'}}</td>
                                       
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive">
                            <table class="mt-2 table w-100 table-invoice table-bordered" v-if="($safe(receipt,'Details') || []).length">
                                <thead>
                                    <tr>
                                       
                                        <th class="w-20 text-nowrap">Ödeme Tutarı (TL)</th>
                                        <th class="w-20 text-nowrap">Toplam Ödenen Tutar (TL)</th>
                                        <th class="w-20 text-nowrap">Kalan Tutar (TL)</th>
                                        <th class="w-20 text-nowrap">Ödenen Tutar (TL)</th>
                                        <th class="w-20 text-nowrap">Ödeme Şekli</th>
                                        <th class="w-20 text-nowrap" v-if="receipt.InstallmentCount != 0">Taksit Tutarı</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(detail,index) in receipt.Details.filter(d=> d.Status != 7 )" :key="index">
                                 
                                        <td class="text-right">{{$safe(detail,'Debt') || '-'}}</td>
                                        <td class="text-right">{{$safe(detail,'PaidPart') || '-'}}</td>
                                        <td class="text-right">{{$safe(detail,'RemainingDebt') || '-'}}</td>
                                        <td class="text-right"><b-badge variant="success"> {{$safe(receipt,'Amount') || '-'}} </b-badge></td>
                                        <td>{{$safe(receipt,'InstallmentCountStr') || '-'}}</td>
                                        <td class="text-right" v-if="receipt.InstallmentCount != 0">{{$safe(receipt,'InstallmentAmount') || '-'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- <div class="invoice-price">
                            <div class="invoice-price-left">
                                <div class="invoice-price-row">
                                </div>
                            </div>
                            <div class="invoice-price-right">
                                <h4>ÖDENEN TUTAR</h4> <span class="font-weight-bolder">{{$safe(receipt,'Amount') || '-'}}₺</span>
                            </div>
                        </div> -->
                   
                    </div>
                    <div class="text-right d-print-none">
                        <h5 class="text-warning">Ödeme işlemini tamamladıysanız sayfayı kapatabilirsiniz. Eğer tamamlamadıysanız "Ödemeye Devam Et" butonu ile işleme devam edebilirsiniz.</h5>
                        <button class="btn btn-sm btn-primary" v-on:click="continuePayment">
                            Ödemeye Devam Et
                            <feather-icon icon="ArrowRightIcon" class="ml-50"></feather-icon>
                        </button>
                    </div>
                    <div class="invoice-note">
                        * Bu faturayla ilgili herhangi bir sorunuz varsa <a :href="`mailto:${mailAddress}`">{{mailAddress}}</a> adresinden ulaşabilirsiniz.
                    </div>
                    <div class="invoice-footer d-print-none">
                        <p class="text-center mb-2 font-weight-bolder">
                            Teşekkür ederiz
                        </p>
                        <p class="text-center">
                            <span class="mr-2">
                                <feather-icon icon="GlobeIcon"></feather-icon>
                                <a class="ml-25" :href="url">{{url}}</a>
                            </span>
                            <span>
                                <feather-icon icon="MailIcon"></feather-icon> 
                                <a class="ml-25" :href="`mailto:${mailAddress}`">{{mailAddress}}</a>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay, BBadge } from 'bootstrap-vue'
import { PaymentApi } from '@/api/payment'
export default {
    components:{
        BOverlay,
        BBadge
    },
    data() {
        return {
            code:this.$route.params?.code || null,
            receipt:null,
            mailAddress:this.$param('company.account.email') || '-',
            url:this.$param('company.website.url') || '-',
            loading:false
        }
    },
    mounted(){
        this.getReceipt()
    },
    methods:{
        continuePayment(){
            this.$router.push({name:'payment',params:{code:this.receipt.PaymentCode}})
        },
        getReceipt(){
            this.loading = true
            PaymentApi.GetReceipt(this.code).then(res=>{
                if(res.data.Success){
                    this.receipt = res.data.Data
                    if(this.receipt?.IsPaymentSuccessfull == false){
                        if(this.receipt.PaymentCode && this.receipt.SystemReceiptCode){
                            this.$router.push({name:'payment-error',params:{paymentCode:this.receipt.paymentCode,receiptCode:this.receipt.SystemReceiptCode}})
                        }else{
                            this.$router.push({name: 'error-404'})
                        }
                    }
                    this.loading = false
                }else this.$result(res)
            }).catch(err=>{
                this.$result(null,err)
            })
        },
        print(){
            window.print()
        } 
    }
}
</script>

<style>
    .logo{
        max-width: 220px;
        width: 30vw;
        height: auto;
        object-fit: scale-down;
    }

    .invoice {
        background: #fff;
        padding: 20px
    }

    .invoice-header {
        margin: 0 -20px;
        background: #f0f3f4;
        padding: 20px
    }

    .invoice-date,
    .invoice-from,
    .invoice-to {
        display: table-cell;
        width: 1%
    }

    .invoice-from,
    .invoice-to {
        padding-right: 20px
    }

    .invoice-date .date,
    .invoice-from strong,
    .invoice-to strong {
        font-size: 16px;
        font-weight: 600
    }

    .invoice-date {
        text-align: right;
        padding-left: 20px
    }

    .invoice-price {
        background: #f0f3f4;
        display: table;
        width: 100%
    }

    .invoice-price .invoice-price-left,
    .invoice-price .invoice-price-right {
        display: table-cell;
        padding: 20px;
        font-size: 20px;
        font-weight: 600;
        width: 75%;
        position: relative;
        vertical-align: middle
    }

    .invoice-price .invoice-price-left .sub-price {
        display: table-cell;
        vertical-align: middle;
        padding: 0 20px
    }

    .invoice-price small {
        font-size: 12px;
        font-weight: 400;
        display: block
    }

    .invoice-price .invoice-price-row {
        display: table;
        float: left
    }

    .invoice-price .invoice-price-right {
        width: 25%;
        background: #2d353c;
        color: #fff;
        font-size: 28px;
        text-align: right;
        vertical-align: bottom;
        font-weight: 300
    }

    .invoice-price .invoice-price-right small {
        display: block;
        opacity: .6;
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 12px
    }

    .invoice-footer {
        border-top: 1px solid #ddd;
        padding-top: 10px;
        font-size: 10px
    }

    .invoice-note {
        color: #999;
        margin-top: 80px;
        font-size: 85%
    }

    .invoice>div:not(.invoice-footer) {
        margin-bottom: 20px
    }
</style>